import { render, staticRenderFns } from "./OperatorMissionPriorityPalletsDetailDataTableCheckRenderer.vue?vue&type=template&id=2239d010&"
import script from "./OperatorMissionPriorityPalletsDetailDataTableCheckRenderer.vue?vue&type=script&lang=ts&"
export * from "./OperatorMissionPriorityPalletsDetailDataTableCheckRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports